import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AXNUISuccessPage } from "@iddataweb/idw-common-ui/containers";
import { getRedirectUrl } from '@redux/selectors/common-selectors';
import { getLanguageContent } from '@redux/selectors/language-selectors';
import {
	getFormPanelLayout,
	getFormPanelTheme,
	getIDPName,
	getLogoPosition,
	getLogoUrl,
	getRPName
} from '@redux/selectors/verification-configuration-selectors';
import { setSubmissionComplete } from '@redux/actions/submission-actions';

type SuccessPageProps = {
	useThemedUI: boolean;
};

export const SuccessPage = (props: SuccessPageProps) => {
	const { useThemedUI } = props;
	const dispatch = useDispatch();
	const redirectUrl = useSelector(getRedirectUrl);
	const content = useSelector(getLanguageContent);
	const idpName = useSelector(getIDPName);
	const relyingPartyName = useSelector(getRPName);
	const logoUrl = useSelector(getLogoUrl);
	const logoPosition = useSelector(getLogoPosition);
	const formPanelTheme = useSelector(getFormPanelTheme);
	const formPanelLayout = useSelector(getFormPanelLayout);

	useEffect(() => {
		dispatch(setSubmissionComplete(true));
	}, []);

	useEffect(() => {
		if (redirectUrl) {
			window.location.href = redirectUrl;
		}
	}, [redirectUrl]);

	return (
		<AXNUISuccessPage
			content={content}
			formPanelLayout={formPanelLayout}
			formPanelTheme={formPanelTheme}
			idpName={idpName}
			logoPosition={logoPosition}
			logoUrl={logoUrl}
			relyingPartyName={relyingPartyName}
			useThemedUI={useThemedUI}
		/>
	);
};